export default "__VITE_ASSET__ef448f30__"